import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLayoutSolutionStore = defineStore('layoutSolution', () => {
  const isActive = ref<boolean>(false);

  function setIsLayoutSolutionActive(active: boolean): void {
    isActive.value = active;
  }
  return {
    // getters
    isActive: isActive,

    // actions
    setIsLayoutSolutionActive,
  };
});
